// File: client/src/components/dashboard/DoughnutChart.js
import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const DoughnutChart = ({ title, data, options }) => {
    const defaultOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: title,
                font: { size: 16 }
            },
        },
    };

    return <Doughnut data={data} options={{ ...defaultOptions, ...options }} />;
};

export default DoughnutChart;